import './layout.css';
import PropTypes from 'prop-types';
import React from 'react';

function InlineInputControlRowNoLabel({
  smallMargin = false,
  children = undefined
}: {
  smallMargin?: boolean,
  children?: React.ReactChild|React.ReactNode|string|null|undefined
}) {
  const rowClass = smallMargin ? 'ifms-input-ctr-row3-small-margin' : 'ifms-input-ctr-row3';

  return (
    <div className={rowClass}>
      {children}
    </div>
  );
}

InlineInputControlRowNoLabel.defaultProps = {
  smallMargin: false,
};

InlineInputControlRowNoLabel.propTypes = {
  smallMargin: PropTypes.bool.isRequired,
};

export default React.memo(InlineInputControlRowNoLabel);
